import { IHttpService, IPromise } from 'angular';
import HttpService from '../http.service';
import { IPackageService } from './package.service';
import { PackageThumbnail } from './package.model';

/* @ngInject */
export default class PaycellPackageService implements IPackageService {
  constructor(
    private $http: IHttpService,
    private httpService: HttpService,
    private $cookies,
    private i18n
  ) {}

  public getPermAndGeneratePassword(
    packet: PackageThumbnail,
    paymentMethodId?: number
  ): IPromise<Response> {
    return this.httpService.extractResponseResult(
      this.$http.post(`hafifmuzik/mobile/paycell/generatePassword`, {
        offerId: packet.id,
        paymentMethodId: paymentMethodId
      })
    );
  }

  public validatePasswordAndBuy(
    packet: PackageThumbnail,
    password: string,
    paymentMethodId?: number,
    cardId?: string
  ): IPromise<Response> {
    return this.httpService.extractResponseResult(
      this.$http.post(
        `hafifmuzik/mobile/paycell/checkPasswordAndPerformPayment`,
        {
          offerId: packet.id,
          paymentMethodId: paymentMethodId,
          password: password,
          cardId:cardId
        }
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/package/paycellpackage.service.ts